import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent";
import FilterInTable from "../../../../Manage/FilterInTable";
import styles from "./CommunicationLog.module.scss";

const CommunicationLog = () => {
  const tableData = [
    { date: '20/07/2024', customerName: 'William John', communicationType: 'Call', summary: 'Discussed order issue.' },
    { date: '20/07/2024', customerName: 'William John', communicationType: 'Email', summary: 'Sent "Thank you for your purchase!" email.' },
    { date: '20/07/2024', customerName: 'William John', communicationType: 'Call', summary: 'Discussed order issue.' },
    { date: '20/07/2024', customerName: 'William John', communicationType: 'Call', summary: 'Discussed order issue.' },
    { date: '20/07/2024', customerName: 'William John', communicationType: 'Call', summary: 'Discussed order issue.' },
    { date: '20/07/2024', customerName: 'William John', communicationType: 'Call', summary: 'Discussed order issue.' },
    { date: '20/07/2024', customerName: 'William John', communicationType: 'Call', summary: 'Discussed order issue.' },
    { date: '20/07/2024', customerName: 'William John', communicationType: 'Call', summary: 'Discussed order issue.' },
    { date: '20/07/2024', customerName: 'William John', communicationType: 'Call', summary: 'Discussed order issue.' },
    { date: '20/07/2024', customerName: 'William John', communicationType: 'Call', summary: 'Discussed order issue.' },
  ];

  const columns = [
    { name: "Date", selector: (row) => row.date, minWidth: "120px" },
    {
      name: "Customer Name",
      selector: (row) => row.customerName,
      minWidth: "160px",
    },
    {
      name: "Communication Type",
      selector: (row) => row.communicationType,
      minWidth: "200px",
    },
    {
      name: "Summary",
      selector: (row) => row.summary,
      grow: 2,
      minWidth: "180px",
    },
    {
      name: "Action",
      cell: () => (
        <div className="d-flex gap-2">
          <button className={styles["action-button"]}>View</button>
          <button className={styles["action-button"]}>Edit</button>
        </div>
      ),
      minWidth: "120px",
    },
  ];

  return (
    <div className={styles["wrapper"]}>
      <FilterInTable componentName="CRM Communication Log" />
      <div className="mt-3" />
      <DatatableComponent
        data={tableData}
        columns={columns}
        type="yellow-bordered"
        pagination
      />
    </div>
  );
};

export default CommunicationLog;